import React from 'react';
import './CreateCampaignsSideMenu.css';

export const campaignsTypes = {
    custom: 'CUSTOM',
    time: 'TIME',
    volume: 'VOLUME',
};

const CreateCampaignsSideMenu = (props) => {
    const {selectCampaign} = props;
    return (
        <div className='campaigns-side-menu'>
            <button type="button"
                    className="campaigns-side-menu-button volume-campaign-button"
                    onClick={() => selectCampaign(campaignsTypes.volume)}>
                volume campaign
            </button>
            <button type="button"
                    className="campaigns-side-menu-button location-campaign-button"
                    onClick={() => selectCampaign(campaignsTypes.custom)}>
                custom campaign
            </button>
            <button type="button"
                    disabled={true}
                    className="campaigns-side-menu-button time-campaign-button"
                    onClick={() => selectCampaign(campaignsTypes.time)}>
                time campaign
            </button>
        </div>
    )
};

export default CreateCampaignsSideMenu;
